import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from 'kea-resource';

import { Camion } from "./camion";
import { Guia } from "./guia";
import { CajaRuta } from "./cajaruta";

const controller = rpcController("ViajeRuta");

export const ViajeRuta = cacheResource({
    /**Crea un viaje de ruta */
    CrearViaje: async (model: models.NuevoViajeRutaModel): Promise<void> => await controller("CrearViaje", {}, model),

    /**Obtiene los segmentos sugeridos para un nuevo viaje */
    ObtenerSugerenciasSegmento: async (idCamion: number, idSucursalOrigen?: number): Promise<models.SugerenciaSegmento[]> => await controller('ObtenerSugerenciasSegmento', { idSucursalOrigen, idCamion }),

    /**Cancela un viaje */
    CancelarViaje: async (idViaje: number): Promise<void> => await controller('CancelarViaje', { idViaje }),

    /**Le da salida a un viaje */
    DarSalida: async (idViaje: number): Promise<void> => await controller('DarSalida', { idViaje }),

    /**Le da llegada a un viaje */
    DarLlegada: async (idViaje: number): Promise<void> => await controller('DarLlegada', { idViaje }),

    /**Consulta un conjunto de viajes */
    ConsultarViajes: async (filtro: models.FiltroViajeList): Promise<models.ViajeRutaDto[]> => await controller('ConsultarViajes', {}, filtro),

    /**Obtiene el reorte de manifiesto de viaje */
    ReporteDeManifiesto: async (idViaje: number): Promise<string> => await controller('ReporteDeManifiesto', { idViaje }),

}, {
        //No deben de tener cache las consultas
    }, {
        CrearViaje: true,
        CancelarViaje: true,
        DarSalida: true,
        DarLlegada: true,
    });

addOnInvalidateHandler(ViajeRuta, () => invalidateResource(Camion));
addOnInvalidateHandler(ViajeRuta, () => invalidateResource(Guia));
addOnInvalidateHandler(ViajeRuta, () => invalidateResource(CajaRuta));


// WEBPACK FOOTER //
// ./app/resources/items/viajeruta.tsx